import React from "react";
import Navbar from "../components/sub-comp/Navbar.jsx";
import HeroSection from "../components/Home/Hero";
import AboutJRIIT from "../components/Home/AboutJR";
import ExplorePrograms from "../components/Home/ExplorePrograms";
import BreakingNewsUpdates from "../components/Home/BreakingNewsUpdates";
import AccreditationSection from "../components/Home/NACTEAccreditation";
import PhilosophySection from "../components/Home/PhilosophySection";
import HistorySection from "../components/Home/HistorySection";
import StatisticsSection from "../components/Home/StatisticsSection";
import PartnershipReel from "../components/Home/PartnershipReel";
import UpcomingEvents from "../components/Home/UpocmingEvents";
import CampusNews from "../components/Home/CampusNews";
import WithJRIIT from "../components/Home/StuffSection";
import QuickDownloads from "../components/Home/QuickDownloads";
import FullScreenImage from "../components/Home/ShowcaseSection";
import FloatingDegreeIcon from "../components/Home/FloatingDegreeIcon";
import Footer from "../components/sub-comp/MainFooter.jsx";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels.jsx";

function Home() {
  return (
    <div>
      <Navbar />
      <FloatingDegreeIcon />
      <HeroSection />
      <ExplorePrograms />
       <StatisticsSection />
     <AboutJRIIT />
      <QuickDownloads />
      <BreakingNewsUpdates />
      <AccreditationSection />
      <PhilosophySection />
      <HistorySection />
      <PartnershipReel />
      <UpcomingEvents />
      <CampusNews />
      <WithJRIIT />
      <FullScreenImage />
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
}

export default Home;
